// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2KT_Y","options":"AnswerScale_options__1v-_5","selected":"AnswerScale_selected__3KqZd"};